import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  id: "app"
};
var _hoisted_2 = {
  id: "nav"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Suspense Simple");

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Suspense Route");

var _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "I'm a loading screen, I'm waiting the view to be ready!", -1);

export function render(_ctx, _cache) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: "/"
  }, {
    default: _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }), _hoisted_4, _createVNode(_component_router_link, {
    to: "/suspense-route"
  }, {
    default: _withCtx(function () {
      return [_hoisted_5];
    }),
    _: 1
  })]), _createVNode(_Suspense, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_router_view)];
    }),
    fallback: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  })]);
}